//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapState, mapMutations} from 'vuex'
// import AMapComponent from 'src/components/common/amapComponent'
export default {
  name: "map-a-component",
  data(){
    return {
      title:'地理位置',
      mapHeight:680,
      longitude:116.404,
      latitude:39.915,
      description:'天安门',
      farmid:'',
      show: false,
      ctime: '',
      nickname: '',
      isZnw: false,
    }
  },
  mounted () {
  },
  updated () {
    if (this.show) {
      this.initMap();
      let _this = this
      window.onpopstate = function (e) {
        _this.show = false;
      }
    }

  },
  computed: {
    mapStyle () {
      return {
        width:'100%',
        height:this.mapHeight +'px'
      }
    },
  },
  methods: {
    //初始化获取数据
    initMap () {
      let longitude = this.longitude;
      let latitude = this.latitude;
      var map = new AMap.Map('amapContainer', {
        zoom:15,//级别
        center: [longitude, latitude],//中心点坐标
        viewMode:'3D'//使用3D视图
      });
      addMarker();
      function addMarker() {
        map.clearMap();
        var marker = new AMap.Marker({
          map: map,
          position: [longitude, latitude]
        });
      }
    },
    goBack () {
      this.show = false;
      history.back()
    }
  },
  watch: {
    show (newV, oldV) {
      if (newV) {
        let loca = location.href;
        history.pushState({}, 'mapComp', loca+'#map')
      }/*else{
        this.$router.go(-1)
      }*/
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/comm/mapAComponent/mapAComponent.vue